export const notAllowedMessegerNoticeId = 'notAllowedMessegerNoticeId'
